import React, { useState } from 'react';
import './AddPaymentComponent.css';
import ENDPOINTS from '../Constants/ApiEndpoints';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../UserAccounts/AuthProvider';

const AddPaymentComponent = ({ invoice, onClose, onSubmit }) => {
    const [paymentMode, setPaymentMode] = useState('CASH');
    const [amount, setAmount] = useState('');
    const [description, setDescription] = useState('');
    const [transactionId, setTransactionId] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [cardType, setCardType] = useState('');
    const [bank, setBank] = useState('');
    const [loading, setLoading] = useState(false);

     const { userData } = useAuth();

    const handleSubmit = async () => {
        if (!amount || parseFloat(amount) <= 0) {
            toast.error('Amount must be a positive number');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                `${ENDPOINTS.ADD_PAYMENT_TO_INVOICE}/${invoice.invoiceId}/pay`,
                null,
                {
                    params: {
                        amount: parseFloat(amount),
                        paymentMode,
                        receivedBy: userData.username
                    }
                }
            );

            toast.success('Payment successful!');  //✅
            onSubmit(); // notify parent to refresh data
            onClose();  // close popup
        } catch (error) {
            console.error('Payment failed:', error);
            toast.error('Payment submission failed.'); //❌
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="payment-popup-overlay">
            <div className="payment-popup">
                <h3>Add Payment</h3>

                <label><strong>Payment Mode:</strong></label>
                <div className="radio-group">
                    {['CASH', 'UPI', 'CARD'].map((mode) => (
                        <label key={mode} className="radio-option">
                            <input
                                type="radio"
                                value={mode}
                                checked={paymentMode === mode}
                                onChange={(e) => setPaymentMode(e.target.value)}
                            />
                            {mode}
                        </label>
                    ))}
                </div>

                <label>Amount:</label>
                <input
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                />

                <label>Description:</label>
                <input
                    type="text"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />

                {paymentMode === 'UPI' && (
                    <>
                        <label>Transaction ID:</label>
                        <input
                            type="text"
                            value={transactionId}
                            onChange={(e) => setTransactionId(e.target.value)}
                        />
                    </>
                )}

                {paymentMode === 'CARD' && (
                    <>
                        <label>Card Number:</label>
                        <input
                            type="text"
                            value={cardNumber}
                            onChange={(e) => setCardNumber(e.target.value)}
                        />

                        <label>Card Type:</label>
                        <select
                            value={cardType}
                            onChange={(e) => setCardType(e.target.value)}
                        >
                            <option value="">Select</option>
                            <option value="Visa">Visa</option>
                            <option value="MasterCard">MasterCard</option>
                            <option value="RuPay">RuPay</option>
                        </select>

                        <label>Bank:</label>
                        <input
                            type="text"
                            value={bank}
                            onChange={(e) => setBank(e.target.value)}
                        />
                    </>
                )}

                <div className="popup-actions">
                    <button onClick={handleSubmit} disabled={loading}>
                        {loading ? 'Submitting...' : 'Submit'}
                    </button>
                    <button onClick={onClose} disabled={loading}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default AddPaymentComponent;
